module.exports = __webpack_public_path__ + "static/media/nakednews-anchors-title.23dd988e.png";